import React from 'react';

import useQuery from '../../helpers/JIFI/useQuery';
import { TableSkeleton } from '@shadcn/components/ui/table.jsx';
import { Badge } from '@shadcn/components/ui/badge';

const fmtDateTime = (d) => (d ? new Date(d).toLocaleString() : '-');

// Event types read better as words than as the stored snake_case.
const typeLabels = {
  status_change: 'Status',
  eta_update: 'ETA',
  exception: 'Exception',
  milestone: 'Milestone',
  asn: 'ASN',
  count: 'Count',
  delay: 'Delay',
};

// Unified container event timeline (Vizion milestones/ETA/exceptions + manual + ASN).
// Reused by the standalone Container Timeline page and the container detail page.
//
// Rows render the backend's `description`; it comes from the same helper that writes the
// comment trail, so a timeline row and its comment read as the same sentence.
const ContainerTimelineView = ({ containerId }) => {
  const [rows, rowsState] = useQuery({
    url: `/container/${encodeURIComponent(containerId)}/timeline`,
    runQuery: !!containerId,
  });

  const data = Array.isArray(rows) ? rows : [];

  return (
    <div className="table-responsive">
      <table className="table table-centered table-nowrap">
        <thead>
          <tr>
            <th>When</th>
            <th>Event</th>
            <th>Source</th>
          </tr>
        </thead>
        {rowsState === 'success' ? (
          <tbody>
            {data.length > 0 ? (
              data.map((e, key) => (
                <tr key={e._id || key}>
                  <td className="text-muted-foreground">{fmtDateTime(e.occurredAt)}</td>
                  <td>
                    <Badge className="badge-soft-secondary font-size-12 mr-2">
                      {typeLabels[e.type] || String(e.type ?? '').replace(/_/g, ' ')}
                    </Badge>
                    {e.description}
                  </td>
                  <td className="text-muted-foreground">{e.source || e.recordedBy || '-'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center">
                  No events for this container
                </td>
              </tr>
            )}
          </tbody>
        ) : (
          <TableSkeleton columns={3} perPage={8} />
        )}
      </table>
    </div>
  );
};

export default ContainerTimelineView;
